// Visit The Stimulus Handbook for more details
// https://stimulusjs.org/handbook/introduction
//
// This example controller works with specially annotated HTML like:
//
// <div data-controller="hello">
//   <h1 data-target="hello.output"></h1>
// </div>

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "element" ]

  connect() {
    this.change()
  }

  change() {
    if(this.element.checkValidity()) {
      this.element.closest('.modal').querySelector('a[data-name="confirm"]').classList.remove('disabled')
    } else {
      this.element.closest('.modal').querySelector('a[data-name="confirm"]').classList.add('disabled')
    }
  }
}
